import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, } from '@angular/forms';
import { FormItem } from './models';
import { BigFormService } from '@flexus/core';

@Component({
	selector: 'dynamic-form-generator',
	templateUrl: './dynamic-form-generator.component.html',
	styleUrls: ['./dynamic-form-generator.component.scss']
})
export class DynamicFormGeneratorComponent implements OnInit {
	@Output() onSubmit = new EventEmitter();
	@Input() fields: FormItem[] = [];
	form: UntypedFormGroup;
	constructor(public bf: BigFormService) {}

	ngOnInit() {
		// let fieldsCtrls = {};
		// for (let f of this.fields) {
		//   if (f.type != 'checkbox') {
		//     fieldsCtrls[f.name] = new FormControl(f.value || '');
		//   } else {
		//     let opts = {};
		//     for (let opt of f.options) {
		//       opts[opt.key] = new FormControl(opt.value);
		//     }
		//     fieldsCtrls[f.name] = new FormGroup(opts);
		//   }
		// }
		// this.bf.patchValues(fieldsCtrls);
		// this.form = new FormGroup(fieldsCtrls);
	}
}
